import { useEffect } from 'react';
import { useVersionStore } from '@/stores/versionStore';

interface UseVersionCheckOptions {
  /** バージョンチェックを有効にするか（デフォルト: true） */
  enabled?: boolean;
  /** 新バージョン検出時に自動更新するか（デフォルト: true） */
  autoUpdate?: boolean;
}

/**
 * バージョンチェックと自動更新を行うhook
 * アプリ起動時（ページロード/リロード時）にバージョンをチェックし、
 * 新バージョンがある場合は自動的にキャッシュクリア + リロードを実行
 */
export const useVersionCheck = (options: UseVersionCheckOptions = {}) => {
  const { enabled = true, autoUpdate = true } = options;
  const { checkForUpdate, performUpdate } = useVersionStore();

  useEffect(() => {
    if (!enabled) return;

    const check = async () => {
      const hasUpdate = await checkForUpdate();

      if (hasUpdate && autoUpdate) {
        // 新バージョン検出時は即座に更新
        await performUpdate();
      }
    };

    check();
  }, [enabled, autoUpdate, checkForUpdate, performUpdate]);
};
